/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Optional object that is returned if a bookmark was made on a planet or a random location in space.
 * @export
 * @interface GetCharactersCharacterIdBookmarksCoordinates
 */
export interface GetCharactersCharacterIdBookmarksCoordinates {
    /**
     * x number
     * @type {number}
     * @memberof GetCharactersCharacterIdBookmarksCoordinates
     */
    x: number;
    /**
     * y number
     * @type {number}
     * @memberof GetCharactersCharacterIdBookmarksCoordinates
     */
    y: number;
    /**
     * z number
     * @type {number}
     * @memberof GetCharactersCharacterIdBookmarksCoordinates
     */
    z: number;
}

/**
 * Check if a given object implements the GetCharactersCharacterIdBookmarksCoordinates interface.
 */
export function instanceOfGetCharactersCharacterIdBookmarksCoordinates(value: object): value is GetCharactersCharacterIdBookmarksCoordinates {
    if (!('x' in value) || value['x'] === undefined) return false;
    if (!('y' in value) || value['y'] === undefined) return false;
    if (!('z' in value) || value['z'] === undefined) return false;
    return true;
}

export function GetCharactersCharacterIdBookmarksCoordinatesFromJSON(json: any): GetCharactersCharacterIdBookmarksCoordinates {
    return GetCharactersCharacterIdBookmarksCoordinatesFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdBookmarksCoordinatesFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdBookmarksCoordinates {
    if (json == null) {
        return json;
    }
    return {
        
        'x': json['x'],
        'y': json['y'],
        'z': json['z'],
    };
}

export function GetCharactersCharacterIdBookmarksCoordinatesToJSON(json: any): GetCharactersCharacterIdBookmarksCoordinates {
    return GetCharactersCharacterIdBookmarksCoordinatesToJSONTyped(json, false);
}

export function GetCharactersCharacterIdBookmarksCoordinatesToJSONTyped(value?: GetCharactersCharacterIdBookmarksCoordinates | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'x': value['x'],
        'y': value['y'],
        'z': value['z'],
    };
}

